import React, { FunctionComponent } from 'react';

import useBasePageQuery from '../../hooks/useBasePageQuery';

interface PageTitleProps {
  className?: string;
  truncateAt?: number;
  id?: string;
}

const TruncatedPageOwnerTitle: FunctionComponent<PageTitleProps> = ({
  className,
  truncateAt,
  id,
}) => {
  const { data: basePageData } = useBasePageQuery();

  const { title } = basePageData?.page ?? {};

  return (
    <>
      {title && (
        <h1 data-qa="page-owner-title" className={className} id={id}>
          {truncateAt && title.length > truncateAt
            ? `${title.slice(0, truncateAt)}...`
            : `${title}`}
        </h1>
      )}
    </>
  );
};

export default TruncatedPageOwnerTitle;
